import { QuestionOptionInsert,QuestionOptionInsertMany, QuestionOptionDelete, QuestionOptionUpdate, QuestionOptionGetById, QuestionOptionGetList, QuestionOptionGetPageList } from "@/api/questionoption/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    QuestionOptionInsert(context, payload) {
        return new Promise((resolve, reject) => {
            QuestionOptionInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 新增
    QuestionOptionInsertMany(context, payload) {
        return new Promise((resolve, reject) => {
            QuestionOptionInsertMany(payload).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    QuestionOptionUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            QuestionOptionUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    QuestionOptionGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            QuestionOptionGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    QuestionOptionGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            QuestionOptionGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    QuestionOptionGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            QuestionOptionGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}